import { render, staticRenderFns } from "./KrStatusBadge.vue?vue&type=template&id=442cc8b1&scoped=true&"
import script from "./KrStatusBadge.vue?vue&type=script&lang=js&"
export * from "./KrStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./KrStatusBadge.vue?vue&type=style&index=0&id=442cc8b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442cc8b1",
  null
  
)

export default component.exports